module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (226).679e036b.jpg";